module.exports = __webpack_public_path__ + "static/media/corkBoardBackground.1724bd40.jpg";